import { defineMessages } from 'react-intl';

export const productTableMessages = defineMessages({
  nameHeader: {
    id: 'productTable.nameHeader',
    defaultMessage: 'Name',
    description: 'Product table name header',
  },
  descriptionHeader: {
    id: 'productTable.descriptionHeader',
    defaultMessage: 'Description',
    description: 'Product table description header',
  },
  versionHeader: {
    id: 'productTable.versionHeader',
    defaultMessage: 'Version',
    description: 'Product table version header',
  },
  statusHeader: {
    id: 'productTable.statusHeader',
    defaultMessage: 'Status',
    description: 'Product table status header',
  },
  updatedOnHeader: {
    id: 'productTable.updatedOnHeader',
    defaultMessage: 'Updated on',
    description: 'Product table updatedOn header',
  },
  projectIdentifierHeader: {
    id: 'productTable.projectIdentifierHeader',
    defaultMessage: 'Project Identifier',
    description: 'Product table projectIdentifier header',
  },
  productIdentifierHeader: {
    id: 'productTable.productIdentifierHeader',
    defaultMessage: 'Product Identifier',
    description: 'Product table productIdentifier header',
  },
  navigatorIdentifierHeader: {
    id: 'productTable.navigatorIdentifierHeader',
    defaultMessage: 'Navigator Identifier',
    description: 'Product table navigatorIdentifier header',
  },
  actionsHeader: {
    id: 'productTable.actionsHeader',
    defaultMessage: 'Actions',
    description: 'Product table actions header',
  },
  updatedOn: {
    id: 'productTable.updatedOn',
    defaultMessage: '{date} at {time}',
    description: 'Product table updatedOn',
  },
  actionsEdit: {
    id: 'productTable.actionsEdit',
    defaultMessage: 'Edit product',
    description: 'Product table actions edit',
  },
  actionsSetAsRetired: {
    id: 'productTable.actionsSetAsRetired',
    defaultMessage: 'Retire product',
    description: 'Product table actions retire',
  },
  actionsSetAsActive: {
    id: 'productTable.actionsSetAsActive',
    defaultMessage: 'Activate product',
    description: 'Product table actions activate',
  },
  actionsDelete: {
    id: 'productTable.actionsDelete',
    defaultMessage: 'Delete product',
    description: 'Product table actions delete',
  },
});
